
      var _rect, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgMessage = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 44,
  height: 44,
  viewBox: "0 0 81 80",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  x: 17.833,
  y: 28,
  width: 45.333,
  height: 14.667,
  rx: 2.667,
  fill: "var(--theme-light, #f9f3fb)",
  stroke: "var(--theme-primary, #810ea9)",
  strokeWidth: 1.5,
  strokeLinejoin: "round"
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M29.167 35.333c-1.915.416-2.252.753-2.667 2.667-.416-1.915-.752-2.252-2.667-2.667 1.914-.415 2.251-.752 2.667-2.666.415 1.914.752 2.251 2.667 2.666ZM38.5 35.333c-1.914.416-2.252.753-2.667 2.667-.415-1.915-.752-2.252-2.666-2.667 1.914-.415 2.25-.752 2.666-2.666.415 1.914.753 2.251 2.667 2.666ZM47.833 35.333c-1.914.416-2.251.753-2.666 2.667-.416-1.915-.753-2.252-2.667-2.667 1.914-.415 2.251-.752 2.666-2.666.416 1.914.753 2.251 2.667 2.666ZM57.167 35.333c-1.915.416-2.252.753-2.667 2.667-.416-1.915-.752-2.252-2.667-2.667 1.914-.415 2.251-.752 2.666-2.666.416 1.914.753 2.251 2.668 2.666Z",
  fill: "var(--theme-primary, #810ea9)",
  stroke: "var(--theme-primary, #810ea9)",
  strokeWidth: 0.5,
  strokeLinejoin: "round"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M65.833 16H15.167a4 4 0 0 0-4 4v30.667a4 4 0 0 0 4 4h4.666a2.667 2.667 0 0 1 2.667 2.666v6.435c0 1.139 1.336 1.753 2.201 1.012l11.05-9.471a2.667 2.667 0 0 1 1.736-.642h28.346a4 4 0 0 0 4-4V20a4 4 0 0 0-4-4Z",
  stroke: "#000",
  strokeWidth: 1.5
})));

      const __svgRaw = "<svg width=\"44\" height=\"44\" viewBox=\"0 0 81 80\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\r\n<rect x=\"17.8333\" y=\"28\" width=\"45.3333\" height=\"14.6667\" rx=\"2.66667\" fill=\"var(--theme-light, #f9f3fb)\" stroke=\"var(--theme-primary, #810ea9)\" stroke-width=\"1.5\" stroke-linejoin=\"round\"/>\r\n<path d=\"M29.1667 35.3333C27.2522 35.749 26.9151 36.0856 26.5 38C26.0844 36.0852 25.7478 35.7485 23.8333 35.3333C25.7474 34.9181 26.0844 34.5815 26.4995 32.6667C26.9151 34.5815 27.2522 34.9181 29.1667 35.3333Z\" fill=\"var(--theme-primary, #810ea9)\" stroke=\"var(--theme-primary, #810ea9)\" stroke-width=\"0.5\" stroke-linejoin=\"round\"/>\r\n<path d=\"M38.5 35.3333C36.5855 35.749 36.2484 36.0856 35.8333 38C35.4177 36.0852 35.0812 35.7485 33.1667 35.3333C35.0807 34.9181 35.4177 34.5815 35.8328 32.6667C36.2484 34.5815 36.5855 34.9181 38.5 35.3333Z\" fill=\"var(--theme-primary, #810ea9)\" stroke=\"var(--theme-primary, #810ea9)\" stroke-width=\"0.5\" stroke-linejoin=\"round\"/>\r\n<path d=\"M47.8333 35.3333C45.9188 35.749 45.5818 36.0856 45.1667 38C44.7511 36.0852 44.4145 35.7485 42.5 35.3333C44.414 34.9181 44.7511 34.5815 45.1662 32.6667C45.5818 34.5815 45.9188 34.9181 47.8333 35.3333Z\" fill=\"var(--theme-primary, #810ea9)\" stroke=\"var(--theme-primary, #810ea9)\" stroke-width=\"0.5\" stroke-linejoin=\"round\"/>\r\n<path d=\"M57.1667 35.3333C55.2522 35.749 54.9151 36.0856 54.5 38C54.0844 36.0852 53.7478 35.7485 51.8333 35.3333C53.7474 34.9181 54.0844 34.5815 54.4995 32.6667C54.9151 34.5815 55.2522 34.9181 57.1667 35.3333Z\" fill=\"var(--theme-primary, #810ea9)\" stroke=\"var(--theme-primary, #810ea9)\" stroke-width=\"0.5\" stroke-linejoin=\"round\"/>\r\n<path d=\"M65.8333 16H15.1667C12.9575 16 11.1667 17.7909 11.1667 20V50.6667C11.1667 52.8758 12.9575 54.6667 15.1667 54.6667H19.8333C21.3061 54.6667 22.5 55.8606 22.5 57.3333V63.7677C22.5 64.9068 23.8361 65.5214 24.701 64.78L35.751 55.3087C36.2343 54.8944 36.8499 54.6667 37.4865 54.6667H65.8333C68.0425 54.6667 69.8333 52.8758 69.8333 50.6667V20C69.8333 17.7909 68.0425 16 65.8333 16Z\" stroke=\"#000000\" stroke-width=\"1.5\"/>\r\n\r\n</svg>";

      function __resolveCssVarsInSvg(svgMarkup) {
        if (typeof window === 'undefined' || !document?.documentElement) {
          return svgMarkup;
        }

        const htmlEl = document.documentElement;
        const bodyEl = document.body;

        function __readCustomProperty(name) {
          let v = getComputedStyle(htmlEl).getPropertyValue(name).trim();
          if (!v && bodyEl) {
            v = getComputedStyle(bodyEl).getPropertyValue(name).trim();
          }
          return v;
        }

        function __expandVarToken(fullMatch, seen) {
          if (!seen) seen = new Set();
          const m = String(fullMatch)
            .trim()
            .match(/^var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)$/i);
          if (!m) return fullMatch;
          const varName = m[1];
          const fallbackRaw = m[2] != null ? String(m[2]).trim() : '';
          if (seen.has(varName)) {
            return fallbackRaw || fullMatch;
          }
          seen.add(varName);
          let specified = __readCustomProperty(varName);
          if (!specified) {
            return fallbackRaw || fullMatch;
          }
          specified = specified.trim();
          if (/^var\s*\(/i.test(specified)) {
            return __expandVarToken(specified, seen) || fallbackRaw || fullMatch;
          }
          return specified || fallbackRaw || fullMatch;
        }

        return svgMarkup.replace(
          /var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)/gi,
          (fullMatch) => __expandVarToken(fullMatch, new Set())
        );
      }

      function __getSvg() {
        return __resolveCssVarsInSvg(__svgRaw);
      }

      function __getBg() {
        const resolved =__resolveCssVarsInSvg(__svgRaw);

        const encoded = encodeURIComponent(resolved)
          .replace(/'/g, '%27')
          .replace(/"/g, '%22');
        return "url('data:image/svg+xml;charset=utf-8," + encoded + "')"; }

      export default Object.assign(
        new String(__webpack_public_path__ + "Assets/message.1a260848144fa6b089584ade0746429f.svg"),
        {
          React: SvgMessage,
          svgClassName: undefined,
          svg: __getSvg,
          bg: __getBg
        }
      );
      